import store from '@/state/store'

export default [{
        path: '/',
        name: 'default',
        meta: {
            title: 'Login',
            beforeResolve(next) {
                if (store.getters.loggedIn) {
                    next({ name: 'dashboard' })
                    next()
                } else {
                    next()
                }
            }
        },
        component: () =>
            import ('../views/login.vue')
    },
    {
        path: "/dashboard",
        name: "dashboard",
        meta: {
            title: "Dashboard",
            authRequired: true,
        },
        component: () =>
            import ("../views/dashboard.vue"),
    },
    //Branch
    {
        path: "/branches",
        name: "branches",
        meta: {
            title: "Branches",
            authRequired: true,
        },
        component: () =>
            import ("../views/branches/branches.vue"),
    },
    {
        path: '/add-branch-stocks/:id',
        name: 'Add Branch Stocks',
        component: () =>
            import ('../views/branches/branch-add-stocks.vue'),
        meta: {
            title: 'Add Branch Stocks',
            authRequired: true
        }
    },
    {
        path: "/branch-stock/:id",
        name: "branch-stocks",
        meta: {
            title: "Branch Stocks",
            authRequired: true,
        },
        component: () =>
            import ("../views/branches/branch-stocks.vue"),
    },
    {
        path: "/branch-sales/:id",
        name: "branch-sales",
        meta: {
            title: "Branch Sales",
            authRequired: true,
        },
        component: () =>
            import ("../views/branches/branch-sales.vue"),
    },
    //Products
    {
        path: "/items",
        name: "items",
        meta: {
            title: "Product Items",
            authRequired: true,
        },
        component: () =>
            import ("../views/products/list.vue"),
    },
    {
        path: "/sort-items",
        name: "sort-items",
        meta: {
            title: "Sort Product Items",
            authRequired: true,
        },
        component: () =>
            import ("../views/products/sort.vue"),
    },
    {
        path: "/deleted-items",
        name: "deleted-items",
        meta: {
            title: "Deleted Product Items",
            authRequired: true,
        },
        component: () =>
            import ("../views/products/deleted.vue"),
    },
    //Supply Chain
    {
        path: "/suppliers",
        name: "suppliers",
        meta: {
            title: "Suppliers",
            authRequired: true,
        },
        component: () =>
            import ("../views/supply-chain/suppliers.vue"),
    },
    {
        path: "/purchases",
        name: "purchases",
        meta: {
            title: "Purchases",
            authRequired: true,
        },
        component: () =>
            import ("../views/supply-chain/purchases.vue"),
    },
    {
        path: "/purchase-info/:id",
        name: "purchases-info",
        meta: {
            title: "Purchases Information",
            authRequired: true,
        },
        component: () =>
            import ("../views/supply-chain/purchase_info.vue"),
    },
    {
        path: "/warehouse",
        name: "warehouse",
        meta: {
            title: "Warehouse",
            authRequired: true,
        },
        component: () =>
            import ("../views/supply-chain/warehouse.vue"),
    },
    {
        path: '/add-warehouse-stocks/:id',
        name: 'Add Warehouse Stocks',
        component: () =>
            import ('../views/supply-chain/warehouse-add-stock.vue'),
        meta: {
            title: 'Add Warehouse Stocks',
            authRequired: true
        }
    },

    {
        path: "/stock-receivables",
        name: "stock-receivables",
        meta: {
            title: "Stock Receivables",
            authRequired: true,
        },
        component: () =>
            import ("../views/supply-chain/stock-receivable.vue"),
    },
    {
        path: "/branch-request",
        name: "branch-request",
        meta: {
            title: "Branch Request",
            authRequired: true,
        },
        component: () =>
            import ("../views/branches/branch-request.vue"),
    },
    {
        path: "/other-request",
        name: "other-request",
        meta: {
            title: "Other Request",
            authRequired: true,
        },
        component: () =>
            import ("../views/supply-chain/other-request.vue"),
    },
    {
        path: "/pullout-request",
        name: "pullout-request",
        meta: {
            title: "Pull Out Request",
            authRequired: true,
        },
        component: () =>
            import ("../views/supply-chain/pull-out.vue"),
    },
    {
        path: "/warehouse-stocks/:id",
        name: "warehouse-stocks",
        meta: {
            title: "Warehouse Stocks",
            authRequired: true,
        },
        component: () =>
            import ("../views/supply-chain/warehouse-stocks.vue"),
    },
    //Logistics
    {
        path: "/drivers",
        name: "drivers",
        meta: {
            title: "Drivers",
            authRequired: true,
        },
        component: () =>
            import ("../views/logistics/drivers.vue"),
    },
    {
        path: "/trucks",
        name: "trucks",
        meta: {
            title: "Trucks",
            authRequired: true,
        },
        component: () =>
            import ("../views/logistics/trucks.vue"),
    },
    {
        path: "/warehouse-pullout",
        name: "warehouse-pullout",
        meta: {
            title: "Warehouse Pullout",
            authRequired: true,
        },
        component: () =>
            import ("../views/supply-chain/warehouse-pullout.vue"),
    },
    //Settings
    {
        path: "/users",
        name: "users",
        meta: {
            title: "System Users",
            authRequired: true,
        },
        component: () =>
            import ("../views/settings/users.vue"),
    },
    {
        path: "/roles",
        name: "roles",
        meta: {
            title: "Role Base Access",
            authRequired: true,
        },
        component: () =>
            import ("../views/settings/roles.vue"),
    },
    {
        path: "/add-role",
        name: "add-role",
        meta: {
            title: "Add New Role",
            authRequired: true,
        },
        component: () =>
            import ("../views/settings/add-role.vue"),
    },
    {
        path: "/roles-perm/:id",
        name: "role-permissions",
        meta: {
            title: "Role Permissions",
            authRequired: true,
        },
        component: () =>
            import ("../views/settings/role-permissions.vue"),
    },
    {
        path: "/set-up-account",
        name: "set-up-account",
        meta: {
            title: "Setup Account",
            authRequired: false,
        },
        component: () =>
            import ("../views/setup-account.vue"),
    }
];